import { render, staticRenderFns } from "./ContentSheet.vue?vue&type=template&id=6e20fb60&scoped=true&"
import script from "./ContentSheet.vue?vue&type=script&lang=js&"
export * from "./ContentSheet.vue?vue&type=script&lang=js&"
import style0 from "./ContentSheet.vue?vue&type=style&index=0&id=6e20fb60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e20fb60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VRow,VSheet})
